export const SOURCE = {
  publicAnnouncement: {
    label: 'financialStatement.PUBLIC_ANNOUNCEMENT',
    value: 9479,
    isI18n: true,
  },
  taxFiling: {
    label: 'financialStatement.TAX_FILING',
    value: 12455,
    isI18n: true,
  },
  creditFiling: {
    label: 'financialStatement.CREDIT_FILING',
    value: 12456,
    isI18n: true,
  },
  other: { label: 'financialStatement.OTHER', isI18n: true, value: 0 },
}

export const TYPE_OF_FS = {
  consolidated: {
    label: 'financialStatement.CONSOLIDATED',
    value: 2,
    isI18n: true,
  },
  unconsolidated: {
    label: 'financialStatement.UNCONSOLIDATED',
    value: 1,
    isI18n: true,
  },
}

export const AUDIT_STATUS = {
  audited: { label: 'financialStatement.AUDITED', value: 1, isI18n: true },
  unaudited: { label: 'financialStatement.UNAUDITED', value: 2, isI18n: true },
}

export const METHOD = {
  direct: { label: 'financialStatement.DIRECT', value: 1, isI18n: true },
  indirect: { label: 'financialStatement.INDIRECT', value: 2, isI18n: true },
}

export const TAB_LIST = {
  BALANCE_SHEET: {
    label: 'financialStatement.BALANCE_SHEET',
    key: 1,
  },
  INCOME_STATEMENT: {
    label: 'financialStatement.INCOME_STATEMENT',
    key: 2,
  },
  CASH_FLOW_STATEMENT: {
    label: 'financialStatement.CASH_FLOW_STATEMENT',
    key: 3,
  },
}

export const DIRECT = 'direct'
